import type { UserRoleResponse } from '@/api/auth/missionImpactAuthAPI.schemas';

/**
 * Identity details of the signed-in user used to recognise their own membership row.
 */
export interface CurrentUserIdentity {
  /** Identity provider object ID of the signed-in user. */
  oid?: string | null;
  /** Email addresses known for the signed-in user (profile email, account username). */
  emails: (string | null | undefined)[];
}

/**
 * Normalises an email address for case-insensitive comparison.
 */
function normalizeEmail(email: string | null | undefined): string {
  return (email ?? '').trim().toLowerCase();
}

/**
 * Whether a membership role belongs to the signed-in user. Matches on user ID when both sides
 * have one, otherwise on email (case-insensitive).
 */
export function isCurrentUserRole(
  role: Pick<UserRoleResponse, 'userId' | 'email'>,
  identity: CurrentUserIdentity
): boolean {
  if (role.userId && role.userId.toLowerCase() === identity.oid?.toLowerCase()) {
    return true;
  }

  const roleEmail = normalizeEmail(role.email);
  if (!roleEmail) {
    return false;
  }

  return identity.emails.some((email) => normalizeEmail(email) === roleEmail);
}
